<template>
    <v-navigation-drawer
        color="backGroundPrimary"
        v-model="drawer"
        app dark fixed permanent
        :mini-variant.sync="mini"
        expand-on-hover
    >
        <v-list nav>
            <v-list-item class="mb-7">
                <v-list-item-title class="p-relative">
                    <v-img v-show="mini" eager max-width="25" :src="imgPlaceholder"/>
                    <v-img v-show="!mini" eager max-width="151" :src="require('@/assets/img/logo_sidebar.png')"/>
                </v-list-item-title>
            </v-list-item>
            <v-list-item
                v-for="(item, index) in itemsNoProfile"
                :key="index"
                :ref="item.ref"
                :to="item.link || null"
                color="primary" link
            >
                <v-list-item-icon>
                    <div v-if="item.count && item.count > 0" class="badge">
                        {{ item.count }}
                    </div>
                    <v-icon size="25">{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title class="list-title">{{ item.title }}</v-list-item-title>
            </v-list-item>
        </v-list>

        <template v-slot:append>

            <v-list nav>
                <v-list-item ref="profile" :to="profileRoute" color="primary" link>
                    <v-list-item-icon>
                        <v-icon size="25">$account_circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="list-title">{{ $t('common.profile') }}</v-list-item-title>
                </v-list-item>

                <v-list-item v-if="!mini">
                    <v-list-item-content>
                        <v-list-item-title class="username-text">
                            {{ account && account.name || '' }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="email-text">
                            {{account && account.email || '' }}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-divider style="border-width: 1px; border-color: #FFFFFF"/>

                <v-list-item link @click="logout">
                    <v-list-item-icon>
                        <v-icon size="25">$logout</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="list-title">{{ $t('entrance.logout') }}</v-list-item-title>
                </v-list-item>
            </v-list>

        </template>

    </v-navigation-drawer>
</template>

<script>
import {links} from "@/mixins/baseGlobalMixin";

import firebase from 'firebase/app'
import 'firebase/auth'

export default {
    name: "NavigationDrawer",
    mixins: [links],
    data() {
        return {
            drawer: false,
            mini: true,
        }
    },
    computed: {
        itemsNoProfile(vm = this) {
            return vm.items.filter(item => item.ref !== 'profile')
        },
        profileRoute(vm = this) {
            switch (vm.account?.accountType) {
                case 'student':
                    return {name: 'student.profile'}
                case 'coach':
                case 'coach_company':
                    return {name: 'coach.profile'}
                case 'company':
                    return {name: 'company.profile'}
            }
        }
    },
    methods: {
        async logout() {
            const vm = this
            await firebase.auth().signOut()
            await vm.$router.replace({name: 'login'})
        },
        setMini() {
            const vm = this
            vm.mini = !vm.mini
        }
    }
}
</script>

<style scoped>

.theme--light.v-navigation-drawer .v-btn:not(.v-btn--active),
.theme--light.v-navigation-drawer__append .v-btn:not(.v-btn--active),
.theme--light.v-bottom-navigation .v-btn:not(.v-btn--active) {
    color: var(--v-primary-base) !important;
}

.badge {
    opacity: 1 !important;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    color: #fff;
    top: 3px !important;
    right: 7px !important;
    width: 17px;
    height: 17px;
    border-radius: 17px;
    font-size: 13px;
    background-color: var(--v-secondary-base);
}

.list-title {
    font-weight: 300;
    font-size: 14px;
    line-height: 17px;
}

.v-list--nav .v-list-item, .v-list--nav .v-list-item:before {
    border-radius: 0;
}

.username-text {
    font-weight: 300;
    font-size: 14px;
    line-height: 17px;
    color: #FEFEFE;
}

.email-text {
    font-weight: 300;
    font-size: 12px;
    line-height: 14px;
    color: #FEFEFE;
    margin-top: 20px;
}

.icon-mini-variant {
    position: absolute;
    right: 0;
    top: 4px;
}

::v-deep ::-webkit-scrollbar {
    width: 4px;
}

::v-deep ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
}

::v-deep ::-webkit-scrollbar-thumb {
    background: #666666;
    border-radius: 50px;
}

::v-deep ::-webkit-scrollbar-thumb:hover {
    background: #727272;
}

::v-deep ::-webkit-scrollbar-thumb:active {
    background: #727272;
}

::v-deep ::-webkit-scrollbar-track {
    background: transparent;
}

::v-deep ::-webkit-scrollbar-track:hover {
    background: transparent;
}

::v-deep ::-webkit-scrollbar-track:active {
    background: transparent;
}

::v-deep ::-webkit-scrollbar-corner {
    background: transparent;
}

</style>
